/**
 * Created by Yair on 13/12/2016.
 */

import _ from 'lodash';

export function identify(profile) {
    const userTraits = {
        studio_name: profile.programmers[0].programmerName,
        email: profile.username,
        user_type: profile.employeeType,
        account_name: profile.accountName,
        account_manager_name: profile.accountManagerName,
        account_sales_rep: profile.accountSalesRep,
        application: 'Wochit Mobile Uploader'
    };

    if (profile.UTM) {
        const UTMObj = {
            'UTM Content': profile.UTM.UTMContent,
            'UTM Term': profile.UTM.UTMTerm,
            'UTM Name': profile.UTM.UTMCampaign,
            'UTM Medium': profile.UTM.UTMedium,
            'UTM Source': profile.UTM.UTMSource
        };

        Object.assign(userTraits, _.pick(UTMObj, val => !!val));
    }

    window.analytics.identify(profile.employeeId, userTraits);
}

export function track(message, params) {
    Object.assign(params, { application: 'MOJO'});
    window.analytics.track("MOJO: " + message, params);
}


